import { LucideIcon } from "lucide-react";
import { Card } from "@/components/ui/card";

interface MetricsCardProps {
  icon: LucideIcon;
  iconColor: string;
  iconBgColor: string;
  title: string;
  value: string | number;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  subtitle?: string;
}

const MetricsCard = ({
  icon: Icon,
  iconColor,
  iconBgColor,
  title,
  value,
  trend,
  subtitle,
}: MetricsCardProps) => {
  return (
    <Card className="p-8 h-full bg-gradient-to-br from-white to-gray-50 hover:shadow-lg transition-all duration-300 border border-gray-100 group">
      <div className="flex flex-col items-center text-center h-full space-y-4">
        <div 
          className={`p-6 rounded-full ${iconBgColor} shadow-lg transform group-hover:scale-110 transition-all duration-300 ease-in-out`}
        >
          <Icon className={`h-10 w-10 ${iconColor}`} strokeWidth={1.5} />
        </div>
        
        <div className="space-y-3">
          <h3 className="text-sm font-semibold text-gray-600 tracking-wide uppercase">
            {title}
          </h3>
          
          <p className="text-4xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#9b87f5] to-[#8B5CF6]">
            {value}
          </p>
          
          {trend && (
            <div 
              className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                trend.isPositive 
                  ? 'text-green-700 bg-green-50 border border-green-100 hover:bg-green-200' 
                  : 'text-red-700 bg-red-50 border border-red-100 hover:bg-red-200'
              }`}
            >
              {trend.value}
            </div>
          )}
        </div>
        
        {subtitle && (
          <p className="text-sm text-gray-500 leading-relaxed font-medium mt-2">
            {subtitle}
          </p>
        )}
      </div>
    </Card>
  );
};

export default MetricsCard;